module.exports = __webpack_public_path__ + "static/media/health_somatic_yoga_online.a5e73826.webp";